var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDotnet = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39 15",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.251 13.837q0 .473-.333.818T1.11 15q-.464 0-.787-.345A1.16 1.16 0 0 1 0 13.837q0-.485.323-.824.323-.34.787-.34.475 0 .808.345t.333.82M16.383 14.763h-2.059L6.852 2.996A5.4 5.4 0 0 1 6.4 2.07h-.061q.08.473.08 2.027v10.666H4.721V.001h2.203l7.248 11.58q.435.69.586.988h.04q-.101-.638-.102-2.17V0h1.687zM27.26 14.763h-7.672V.001h7.34v1.564h-5.645v4.91h5.23v1.566h-5.23v5.157h5.978zM38.899 1.565h-4.17v13.198h-1.696V1.565h-4.178V0h10.044z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDotnet);
export default ForwardRef;